import { render, staticRenderFns } from "./DetailSupplier.vue?vue&type=template&id=2bf07fd0&scoped=true"
import script from "./DetailSupplier.vue?vue&type=script&lang=js"
export * from "./DetailSupplier.vue?vue&type=script&lang=js"
import style0 from "./DetailSupplier.vue?vue&type=style&index=0&id=2bf07fd0&prod&lang=css&scoped=true"
import style1 from "./DetailSupplier.vue?vue&type=style&index=1&id=2bf07fd0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf07fd0",
  null
  
)

export default component.exports